export default [
    {
        path: "/shop/detail/:id",
        name: "shop.detail",
        meta: {
          title: "商品详情",
        },
        component: () => import("./shopDetail")
      },
      {
        path: "/shop/subOrder",
        name: "shop.subOrder",
        meta: {
          title: "确认订单",
        },
        component: () => import("./subOrder")
      },
      {
        path: "/shop/address",
        name: "shop.address",
        meta: {
          title: "收货地址",
        },
        component: () => import("./addAddress")
      },
      {
        path: "/shop/roleInformation",
        name: "shop.roleInformation",
        meta: {
          title: "添加角色",
        },
        component: () => import("./roleInformation")
      },
      {
        path: "/shop/payment",
        name: "shop.payment",
        meta: {
          title: "订单支付",
        },
        component: () => import("./shopPayment")
      },
      {
        path: "/pay/success",
        name: "pay.success",
        meta: {
          title: "支付成功",
        },
        component: () => import("./PaySuccess")
      },
]